import axios from "axios";
import {
  ApiWalletCustomerResponse,
  ApiWalletTransactionsResponse,
  WalletTopUpBody,
  WalletTopUpResponse,
  WalletTransactionsParams,
} from "../wallet/walletTypes";

/**
 * Stored-balance wallet, proxied by prepareit-backend to the wallet
 * microservice. Every call here needs a signed-in customer token; the backend
 * answers a visitor token with 401. The presets are not fetched from the
 * browser at all -- they are baked into the wallet pages
 * (getWalletPresetsStaticProps).
 */

/**
 * Fails (ProxyWalletService_UpstreamError) for a customer who has never topped
 * up: the wallet service only opens an account on the first credit.
 */
export const getWalletCustomer = async (
  restaurantId: number
): Promise<{ data: ApiWalletCustomerResponse }> => {
  return await axios.get(`/proxy-wallet/customer`, {
    params: { restaurantId },
  });
};

/** Newest first, cursor-paginated. The backend defaults `limit` to 5. */
export const getWalletTransactions = async (
  params: WalletTransactionsParams
): Promise<{ data: ApiWalletTransactionsResponse }> => {
  return await axios.get(`/proxy-wallet/transactions`, { params });
};

/** Starts a Paymob payment for the top-up; send the customer to `payment_link`. */
export const createWalletTopUp = async (
  body: WalletTopUpBody
): Promise<{ data: WalletTopUpResponse }> => {
  return await axios.post(`/wallet/top-up`, body);
};

/**
 * Releases the balance held against an online order the customer walked away
 * from. A no-op server-side when the receipt used no wallet balance.
 */
export const unholdWalletPayment = async (receiptId: number) => {
  return await axios.post(`/proxy-wallet/unhold`, { receiptId });
};
